export default __webpack_public_path__ + "static/media/nodejs.51fb0cf6.svg";